import { render } from "./ExtranetFeatureFlags.vue?vue&type=template&id=287a8911&scoped=true"
import script from "./ExtranetFeatureFlags.vue?vue&type=script&lang=js"
export * from "./ExtranetFeatureFlags.vue?vue&type=script&lang=js"

import "./ExtranetFeatureFlags.vue?vue&type=style&index=0&id=287a8911&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287a8911"]])

export default __exports__